<template>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(salvarOscip)">
            <b-overlay :show="screenBlocked">
                <b-card header-tag="header" class="m-3" no-body>
                    <template #header>
                        <h6 class="mb-0 text-center">
                            <span class="titulo-sagres font-weight-bold">
                                {{ isEdit ? 'Editar' : 'Nova' }} Perda de Qualificação OSCIP
                            </span>
                            <btn-voltar />
                            <b-button class="float-right m-1" size="sm" type="submit">
                                <font-awesome-icon icon="save" />
                                Salvar
                            </b-button>
                        </h6>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col cols="12" md="3">
                                <default-form-validation-provider label="CNPJ" v-slot="defState">
                                    <b-form-input id="input-cnpj" v-model="oscip.NrCnpj"
                                        type="text" :state="defState.state">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <default-form-validation-provider label="Nome da Entidade" v-slot="defState">
                                    <b-form-input id="input-nome-entidade" v-model="oscip.NmEntidade"
                                        :state="defState.state" type="text">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="9">
                                <default-form-validation-provider label="Endereço" v-slot="defState">
                                    <b-form-input id="input-endereco" v-model="oscip.DeEndereco"
                                        :state="defState.state" type="text">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="4">
                                <default-form-validation-provider label="Cidade" v-slot="defState">
                                    <b-form-input id="input-cidade" v-model="oscip.NmCidade"
                                        :state="defState.state" type="text">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                            <b-col cols="12" md="2">
                                <default-form-validation-provider label="UF" v-slot="defState">
                                    <b-form-input id="input-uf" v-model="oscip.NmUf"
                                        :state="defState.state" type="text">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <default-form-validation-provider label="CEP" v-slot="defState">
                                    <b-form-input id="input-cep" v-model="oscip.NmCep"
                                        :state="defState.state" type="text">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="4">
                                <default-form-validation-provider label="Data da Publicação no DOU" v-slot="defState">
                                    <b-form-datepicker id="date-dt-publicacao-dou" v-model="oscip.DtPublicacaoDou" :state="defState.state"
                                        placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada">
                                    </b-form-datepicker>
                                </default-form-validation-provider>
                            </b-col>
                            <b-col cols="12" md="5">
                                <default-form-validation-provider label="Tipo do Documento" v-slot="defState">
                                    <b-form-input id="input-tipo-documento" v-model="oscip.DeTipoDocumento"
                                        :state="defState.state" type="text">
                                    </b-form-input>
                                </default-form-validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="9">
                                <default-form-validation-provider label="Arquivo" v-slot="defState">
                                    <b-form-file 
                                        placeholder="Nenhum arquivo selecionado" 
                                        v-model="oscip.arquivo"
                                        :state="defState.state"
                                        accept="application/pdf">
                                    </b-form-file>
                                </default-form-validation-provider>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-overlay>
        </b-form>
    </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { ValidationObserver } from "vee-validate";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import oscipService from "@/services/contratacao/oscipService";
import { Oscip } from "@/types/contratacao/oscip";

const CompProps = Vue.extend({
  name: "EditarPerdaDeQualificacaoOscip",
  components: {
    BtnVoltar,
    DefaultFormValidationProvider,
    ValidationObserver,
  },
  props: {
    idPerdaQualificacao: {
      type: String,
      required: false
    }
  }
});

@Component
export default class EditarPerdaDeQualificacaoOscip extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  oscip = new Oscip();
  screenBlocked = false;

  get isEdit() {
    return this.idPerdaQualificacao !== undefined && this.idPerdaQualificacao !== null
  }

  async mounted(): Promise<void> {
    try {
      this.screenBlocked = true;
      if (this.isEdit){
        this.oscip = await oscipService.getPerdaOscipId(this.idPerdaQualificacao)
      }
    } catch (e: any) {
      console.error("Erro ao receber dados da Perda de Qualificação OSCIP", e);
    } finally {
      this.screenBlocked = false;
    }
  }

  async salvarOscip(): Promise<void> {
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
        return;
      }
      this.screenBlocked = true;
      const response = !this.isEdit
        ? await oscipService.salvarOscip(this.oscip)
        : await oscipService.alterarOscip(this.idPerdaQualificacao, this.oscip);
      if (response && response.status == 200) {
        this.$toast.success(`Perda de Qualificação OSCIP salva com sucesso!`);
        this.$router.push("/contratacao/perdas-de-qualificacao-oscip");
      } else {
        this.$toast.error(
          response.data.msg || "Erro ao salvar Perda de Qualificação OSCIP"
        );
      }
    } catch (e: unknown) {
      console.error("Erro ao salvar Perda de Qualificação OSCIP", e, this.oscip);
      if (e instanceof Error) {
        this.$toast.error(e.message);
      } else {
        this.$toast.error("Erro ao salvar Perda de Qualificação OSCIP.");
      }
    } finally {
      this.screenBlocked = false;
    }
  }

}
</script>

<style></style>